const Verified = ({ verified }) => {
  if (!verified) {
    return null;
  }

  return (
    <span className="verified">
      <i className="fa fa-circle-check" />
    </span>
  )
}

export default Verified;
